import { createUserAccount } from '../services/createUser';
import {
  deleteProfile,
  fetchProfiles,
  setProfileArchived,
  setupNewProfile,
} from '../services/profiles';
import { confirmAsk, confirmDelete } from '../store/feedback';
import { fetchAllPaginated } from '../utils/supabaseQuery';

/* Traitements « utilisateurs », sortis de App.js. `deps` porte l'état et les setters du composant ;
   `api` donne accès aux traitements des autres domaines (rempli dans App.js, lu au moment de
   l'appel, donc l'ordre de création n'importe pas). */
export default function usersHandlers(deps, api) {
  const {
    loadAppData,
    newUserForm,
    setAdminUsers,
    setAdminUsersLoading,
    setNewUserError,
    setNewUserForm,
    setNewUserSuccess,
    setShowNewUserModal,
  } = deps;

  async function loadAdminUsers() {
    setAdminUsersLoading(true);
    setAdminUsers(await fetchAllPaginated(fetchProfiles()));
    setAdminUsersLoading(false);
  }

  async function handleCreateUser(e) {
    e.preventDefault();
    setNewUserError('');
    setNewUserSuccess('');
    const fullName = [newUserForm.prenom, newUserForm.nom].filter(Boolean).join(' ');
    const { data, error } = await createUserAccount(fullName, newUserForm);
    if (error || data?.error) {
      const raw = (data?.error || error?.message || '').toLowerCase();
      const msg =
        raw.includes('already') || raw.includes('exists') || raw.includes('existe')
          ? 'Un compte avec cet email existe déjà.'
          : raw.includes('invalid') || raw.includes('invalide')
            ? 'Adresse email invalide.'
            : data?.error || error?.message || 'Une erreur est survenue.';
      setNewUserError(msg);
      return;
    }
    const devId = data.id;
    const tauxContrat = Math.round(((parseFloat(newUserForm.disponibilite) || 5) / 5) * 100);
    await setupNewProfile(devId, newUserForm, tauxContrat);
    setNewUserSuccess(
      `Compte créé pour ${fullName}. Il peut se connecter dès maintenant avec Microsoft.`,
    );
    setNewUserForm({
      nom: '',
      prenom: '',
      email: '',
      role: 'dev',
      typeContrat: 'CDI',
      disponibilite: 5,
      coutHoraire: '',
      joursTravailles: [],
      isCongesValidator: false,
    });
    setShowNewUserModal(false);
    loadAdminUsers();
    await loadAppData();
  }

  async function handleDeleteUser(userId) {
    if (!(await confirmDelete('Supprimer cet utilisateur ?'))) return false;
    await deleteProfile(userId);
    loadAdminUsers();
    await loadAppData();
    return true;
  }

  async function handleArchiveUser(u, archive) {
    if (
      archive &&
      !(await confirmAsk(
        `Archiver ${u.nom || u.email} ? Il disparaîtra des listes (équipe, affectations, feuilles d'heures) mais son temps et son coût resteront comptabilisés.`,
        { title: 'Archivage', confirmLabel: 'Archiver' },
      ))
    )
      return;
    await setProfileArchived(archive, u);
    loadAdminUsers();
    await loadAppData();
  }

  return {
    handleArchiveUser,
    handleCreateUser,
    handleDeleteUser,
    loadAdminUsers,
  };
}
